import Util from '../../../util/index.js';
import DataMap from './datamap';
/*

 */
export default class ChainMap extends DataMap{
  constructor(map, symbol = Symbol('chain')) {
    super();
    this.symbol = symbol;
    ['_valid', 'next', 'prev', 'move', 'setStatus', 'get', 'values'].forEach(method => {
      this[method] = this[method].bind(this);
    });
    if (this._valid(map)) {
      this.defaultIndex = Math.max(map.findIndex(a => a.default), 0);
      this.length = map.length;
      this.index = this.defaultIndex;
      this.status = true;
      super.set(symbol, map);
    }
  }
  reset() {
    this.status = true;
    this.index = this.defaultIndex;
  }
  _valid(map) {
    if (!Util.isArray(map)) {
      throw new Error('constructor arguments must be a Array');
      return false;
    }
    if (this.length > 0) {
      throw new Error('constructor arguments length can\'t be 0');
      return false;
    }
    return true;
  }
  next() {
    if (!this.status) return undefined;
    this.index = (this.index + 1) % this.length;
    return super.get(this.symbol)[this.index];
  }
  prev() {
    if (!this.status) return undefined;
    let _index = (this.index - 1) % this.length;
    while (_index < 0) {
      _index += this.length;
    }
    this.index = _index;
    return super.get(this.symbol)[this.index];
  }
  get() {
    return this.move();
  }
  move(expression) {
    if (!this.status) return undefined;
    const _map = super.get(this.symbol);
    let _index;
    if (Util.isFunction(expression)) {
      _index = _map.findIndex(expression);
    } else if (!Util.isUndefined(expression)) {
      _index = _map.findIndex(a => a === expression);
    } else {
      _index = this.index;
    }
    if (_index > -1) {
      this.index = _index;
      return _map[_index];
    } else {
      return undefined;
    }
  }
  setStatus(status) {
    if (Util.isBoolean(status)) {
      this.status = status;
    } else {
      this.status = !this.status;
    }
  }
  values() {
    const map = super.get(this.symbol);
    return map;
  }
  has(expression) {
    const values = this.values();
    return values.findIndex(expression) > -1;
  }
}